import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=0cde273e&"
import script from "./ClientModal.vue?vue&type=script&lang=js&"
export * from "./ClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cde273e')) {
      api.createRecord('0cde273e', component.options)
    } else {
      api.reload('0cde273e', component.options)
    }
    module.hot.accept("./ClientModal.vue?vue&type=template&id=0cde273e&", function () {
      api.rerender('0cde273e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customer/ClientModal.vue"
export default component.exports